function isDev() {
  return process.env.NODE_ENV !== 'production';
}

export const API_URL = isDev() ? 'http://localhost:3001/' : '/';
export const SOCKET_IO_URL = isDev() ? 'http://localhost:3001' : '';
export const SOCKET_IO_PATH = '/socket.io';

export const SIGN_AUDIO_URL = 'https://radios.srv.br/music/sinalLongo.m4a';
